var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6987 3.48402C25.7666 3.5965 25.8116 3.72126 25.8313 3.85117C25.851 3.98109 25.8448 4.1136 25.8133 4.24114C25.7817 4.36868 25.7253 4.48875 25.6473 4.59448C25.5693 4.70021 25.4712 4.78954 25.3587 4.85735L19.5947 8.33335H25.3333C27.4267 8.33335 29 10.1373 29 12.2053V25.128C29 27.1947 27.4267 29 25.3333 29H6.66667C4.57333 29 3 27.196 3 25.128V12.2053C3 10.1387 4.57333 8.33335 6.66667 8.33335H11.9933L6.61333 4.83868C6.5032 4.76716 6.40823 4.67464 6.33385 4.56641C6.25947 4.45818 6.20714 4.33636 6.17984 4.2079C6.1247 3.94848 6.17488 3.67778 6.31933 3.45535C6.46379 3.23292 6.69069 3.07699 6.95011 3.02185C7.20954 2.96672 7.48024 3.01689 7.70267 3.16135L15.6653 8.33335H15.7213L24.3253 3.14402C24.4378 3.07611 24.5626 3.03104 24.6925 3.01138C24.8224 2.99172 24.9549 2.99785 25.0825 3.02942C25.21 3.061 25.3301 3.1174 25.4358 3.1954C25.5415 3.2734 25.6309 3.37148 25.6987 3.48402Z",
    fill: "#F4F4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvWhite);
export default __webpack_public_path__ + "static/media/tvWhite.221591ba86dfcad0432d49ff07ace18f.svg";
export { ForwardRef as ReactComponent };